// enum to align with the backend

export const CheckStatus = {
    PENDING: 0,
    APPROVED: 1,
    DISCARDED: 2
};